import React, { Component } from 'react'
import Measurements from '../components/Measurements'
import { fetchMeasurements } from '../api';

class MeasurementsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      measurements: []
    }
  }
  componentDidMount() {
    this.getMeasurements()
  }

  getMeasurements = tag => {
    this.setState({ loading: true, search: false, measurements: [] })

    fetchMeasurements().then(res => {
        this.setState({ measurements: res.data, loading: false })
      }).catch(err => {
        console.log(err.response)
        if (err.response.status === 401) {
          this.props.history.push('/login')            
        }
      })
  }

  render() {
    if (Object.keys(this.state.measurements).length === 0) {
      return 'No measurements'
    }
    return (
      <Measurements
        data={this.state.measurements}
      />
    )
  }
}

export default MeasurementsContainer;
